module.exports = __webpack_public_path__ + "img/v1.4fbcc471.png";